import React, { useState, useEffect } from 'react'
import logo from '../../assets/logo.png';
import SignupForm from './SignupForm';
import OTPForm from './OTPForm';
import DealerAssignForm from './DealerAssignForm';
import { Route, Router, Switch, useLocation, useParams } from 'react-router-dom';

const Signup = ({ children, product, setProduct }) => {
    
    let location = useLocation();
    const [title, setTitle] = useState(`Sign in to ${product}`);

    useEffect(() => {
        console.log('location.pathname', location.pathname)
        if (location.pathname.includes('/insightsdashboard/pages/dashboard/signup')) {
            setTitle(`Sign Up to ${product}`);
        } else if (location.pathname.includes('/reset') || location.pathname.includes('/forgot')) {
            setTitle('Reset Password');
        } else if (location.pathname.includes('/insightsdashboard/pages/dashboard/signin')) {
            setTitle(`Sign In to ${product}`);
        } else if (location.pathname.includes('/reset')) {
            setTitle('Reset Password');
        }
       
    }, [location.pathname, product]);


    return (
        <div className="min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-100" >
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-8 w-auto"
                    src={logo}
                    alt={product}
                />

                
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">{title}</h2>

            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" >
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Signup
